/**
 * Formats a citation published date as "18 Jun 2026" to match the
 * citations page design spec.
 */
export function formatCitationDate(date: string): string {
    if (!date) {
        return "";
    }

    return new Date(date).toLocaleString("en-gb", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "utc",
    });
}
